export default [{
        name: '首页',
        path: '/',
        icon: require('../assets/menu/shouye.png'),
        classname:'shouye',
        authority: 'Manage Edit'
    },
    {
        name: '内容管理',
        icon: require('../assets/menu/guanli.png'),
        classname:'guanli',
        authority: 'Manage Edit',
        children: [
            {
                name: '内容审核',
                path: '/manage/contentauditys',
                authority: 'Manage'
            }
        ]
    },
    {
        name: '数据统计',
        icon: require('../assets/menu/tongji.png'),
        classname:'tongji',
        authority: 'Manage Edit',
        children: [
            {
                name: '校园号排行统计',
                path: '/datastatistics/sort',
                authority: 'Manage Edit'
            },
            {
                name: '工作量统计',
                path: '/datastatistics/workload',
                match: 'specifcworkload,workload',
                authority: 'Manage'
            },
        ]
    },
    {
        name: '设置',
        icon: require('../assets/menu/shezhi.png'),
        classname:'shezhi',
        authority: 'Manage Edit',
        children: [{
                name: '账号信息',
                path: '/settings/account',
                authority: 'Manage Edit'
            },
        ]
    }
]



// WEBPACK FOOTER //
// ./src/config/firstEditor.js